/**
 * Navbar Component
 * Modern navigation bar with BookBridge branding
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-12 h-12 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-105">
              <span className="text-white text-xl font-bold">B</span>
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-navy to-indigo-600 bg-clip-text text-transparent">
              BookBridge
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-1">
            <a href="#features" className="px-4 py-2 text-ink font-medium rounded-lg hover:bg-soft transition-colors duration-200">
              Features
            </a>
            <a href="#how-it-works" className="px-4 py-2 text-ink font-medium rounded-lg hover:bg-soft transition-colors duration-200">
              How it Works
            </a>
            <a href="#api" className="px-4 py-2 text-ink font-medium rounded-lg hover:bg-soft transition-colors duration-200">
              API
            </a>
            <a 
              href="https://api-xcelerateai.demotrt.com/api-docs/" 
              target="_blank" 
              rel="noreferrer"
              className="px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              Get Started
            </a>
          </div>

          <button className="md:hidden p-2 rounded-lg hover:bg-soft transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
